/*
JavaScriptプロトタイプ拡張
*/
const extend = {};
// 指定した文字列以降の文字列を削除する。
String.prototype.before = function(word, include) {
  const idx = this.indexOf(word);
  const l = include ? word.length : 0;
  return idx >= 0 ? this.substr(0, idx + l) : '';
};
// 指定した文字列より前の文字列を削除する。
String.prototype.after = function(word, include) {
  const idx = this.indexOf(word);
  const l = include ? 0 : word.length;
  return idx >= 0 ? this.substr(idx + l) : '';
};

// 文字列にあるスペースを決まっている文字でリプレースする。
String.prototype.replaceSpace = function() {
  return this.replaceAll(' ', '<span class="whitespace half"></span>').replaceAll('　', '<span class="whitespace full"></span>');
};

export default extend;
